import React, { useEffect, Fragment } from 'react';
import { Helmet } from "react-helmet";
import { useDispatch } from 'react-redux';

import './App.css'
import ErrorReset from './components/ErrorReset'
import {
    constantsRequest,
} from './redux/auth/actions';
import {
    listEmployeesRequest,
} from './redux/employee/actions';
import {
    getMediaTypesRequest,
    getStoreLocationsRequest,
} from './redux/vehicles/actions';
import {
    rolesRequest,
    teamsRequest,
} from './redux/auth/actions';
// import "react-day-picker/style.css";


function App() {
    const dispatch = useDispatch();
    const [isInitialized, setIsInitialized] = React.useState(false);

    useEffect(() => {
        dispatch(constantsRequest());

        const handleStorageChange = () => {
            if (isInitialized)
                return;

            if (localStorage.getItem("authToken")) {
                setIsInitialized(true);
                window.removeEventListener('storage', handleStorageChange);

                dispatch(getMediaTypesRequest());
                dispatch(rolesRequest());
                dispatch(teamsRequest());
                dispatch(getStoreLocationsRequest());
                dispatch(
                    listEmployeesRequest({
                        filters: "",
                        members_fields: ["id", "user", "avatar", "hour_rate", "weekly_cap"].join(","),
                        excludes: "",
                    })
                );
            }
        };

        window.addEventListener('storage', handleStorageChange);

        // Initial check
        handleStorageChange();

        return () => {
            if (!isInitialized) {
                window.removeEventListener("storage", handleStorageChange);
            }
        };
    }, [dispatch]);

    return (
        <Fragment>
            <Helmet>
                <title>TurboCar - Quality Cars, Unmatched Value, Total Reliability</title>
            </Helmet>
            <ErrorReset />
        </Fragment>
    )
}

export default App;
